<template>
  <div class="document_views">
    <div v-if="htmlScrollParams.length" class="document-compare__controls">
      <button
        type="button"
        class="document-compare__control document-compare__control_html"
        title="Синхронизировать скан"
        @click="handleSyncroWithHtml"
      >
        <svg width="18" height="18">
          <use xlink:href="#chevron" />
        </svg>
      </button>
      <button
        type="button"
        class="document-compare__control document-compare__control_scan"
        title="Синхронизировать текст"
        @click="handleSyncroWithScan"
      >
        <svg width="18" height="18">
          <use xlink:href="#chevron" />
        </svg>
      </button>
    </div>

    <document-html-viewer
      :document-id="documentId"
      :fragment-id="fragmentId"
      :viewMode="'views'"
      :scroll-top="scanScroll"
      :card="card"
      @set-scroll-params="handleHtmlScrollParams"
      @html-scroll-update="changeHtmlScroll"
    />

    <document-scan-viewer
      :pages="pages"
      :document-id="documentId"
      :fragment-id="fragmentId"
      :viewMode="'views'"
      :scroll-top="htmlScroll"
      @scan-scroll-update="changeScanScroll"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DocumentHtmlViewer from '@@/document/DocumentViewer/DocumentHtmlViewer';
import DocumentScanViewer from '@@/document/DocumentViewer/DocumentScanViewer';

export default {
  components: {
    DocumentHtmlViewer,
    DocumentScanViewer
  },

  props: {
    pages: {
      type: Array,
      default: () => []
    },
    fragmentId: {
      type: String
    }
  },

  data() {
    return {
      scanScroll: 0,
      currScanScroll: {
        index: 0,
        shift: 0
      },
      htmlScroll: {
        index: 0,
        shift: 0
      },
      currHtmlScroll: 0,
      htmlScrollParams: []
    };
  },

  computed: {
    ...mapGetters({
      documentId: 'currentDocumentId',
      card: 'currentDocumentInfo',
//      pages: 'currentDocumentScans',
      isLoading: 'documentIsLoading',
      loadErrors: 'loadErrors'
    })
  },

  methods: {
    handleSyncroWithScan() {
      this.scanScroll =
        this.htmlScrollParams[this.currScanScroll.index].top +
        this.currScanScroll.shift *
          this.htmlScrollParams[this.currScanScroll.index].height;
    },
    handleSyncroWithHtml() {
      let index = 0;
      let shift = 0;
      let len = this.htmlScrollParams.length;

      for (let i = 0; i < len; i++) {
        if (this.currHtmlScroll >= this.htmlScrollParams[len - 1].top) {
          index = len - 1;
          shift =
            (this.currHtmlScroll - this.htmlScrollParams[i].top) /
            this.htmlScrollParams[i].height;
          break;
        }
        if (
          this.currHtmlScroll >= this.htmlScrollParams[i].top &&
          this.currHtmlScroll < this.htmlScrollParams[i + 1].top
        ) {
          index = i;
          shift =
            (this.currHtmlScroll - this.htmlScrollParams[i].top) /
            this.htmlScrollParams[i].height;
          break;
        }
      }
      this.htmlScroll = {
        index: index,
        shift: shift
      };
    },
    changeScanScroll({ index, shift }) {
      this.currScanScroll.index = index;
      this.currScanScroll.shift = shift;
    },
    changeHtmlScroll(scroll) {
      this.currHtmlScroll = scroll;
    },
    handleHtmlScrollParams(arr) {
      this.htmlScrollParams = arr.map(i => Object.assign({}, i));
    }
  }
};
</script>
